
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, FileText, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AdminSectionsProps {
  dashboardStats: {
    pendingSubmissions: number;
    approvedSubmissions: number;
    rejectedSubmissions: number;
    pendingPrinterSuggestions: number;
    approvedPrinterSuggestions: number;
    rejectedPrinterSuggestions: number;
    totalComponents: number;
    totalUsers: number;
    totalManufacturers: number;
    totalPrinters: number;
  };
}

const AdminSections = ({ dashboardStats }: AdminSectionsProps) => {
  const navigate = useNavigate();

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Admin Sections</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate('/admin/submissions')}>
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between">
              <CardTitle className="flex items-center gap-2 text-lg">
                <FileText className="h-5 w-5" />
                Submissions
              </CardTitle>
            </div>
            <CardDescription>Manage user submissions</CardDescription>
          </CardHeader>
          <CardContent className="pt-0">
            <div className="space-y-2">
              <div className="text-2xl font-bold">{dashboardStats.pendingSubmissions} Pending</div>
              <p className="text-xs text-muted-foreground">Component and printer submissions</p>
            </div>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate('/admin/users')}>
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between">
              <CardTitle className="flex items-center gap-2 text-lg">
                <Users className="h-5 w-5" />
                User Management
              </CardTitle>
            </div>
            <CardDescription>Manage user accounts and roles</CardDescription>
          </CardHeader>
          <CardContent className="pt-0">
            <div className="space-y-2">
              <div className="text-2xl font-bold">{dashboardStats.totalUsers} Users</div>
              <p className="text-xs text-muted-foreground">Registered users on the platform</p>
            </div>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate('/admin/settings')}>
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between">
              <CardTitle className="flex items-center gap-2 text-lg">
                <Settings className="h-5 w-5" />
                Platform Settings
              </CardTitle>
            </div>
            <CardDescription>Configure site-wide settings</CardDescription>
          </CardHeader>
          <CardContent className="pt-0">
            <div className="space-y-2">
              <div className="text-2xl font-bold">Configure</div>
              <p className="text-xs text-muted-foreground">Manage site features and access</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminSections;
